import { ADD_PURCHASE_ROWS_KEY } from 'constants/monetate';
import {
  BOUGHT_IN_STORE,
  BROWSE,
  CUSTOM_AISLE,
  ENTERTAINING,
  FAVOURITES,
  INTERSTITIALS,
  MEAL_DEALS,
  MISSED_OFFERS,
  MORE_OF_WHAT_YOU_LOVE,
  MULTI_SEARCH,
  OFFERS,
  ORDER_CONFIRMATION,
  QUICK_SHOP,
  SEARCH,
  SHOP_BY_LIST,
  SHOPPING_LISTS,
  SHOP_FROM_ORDER,
  VIEW_ORDER,
} from 'constants/pageTypes';

import { getPageType } from 'utils/get-page-type';

import { monetateQ } from 'utils/monetate-q';
import { unstashObject } from 'utils/stash';

import {
  getMonetateCombinedProducts,
  getMonetateBreadcrumbs,
  getMonetateCartItems,
  getMonetateCombinedFavourites,
  getMonetateQuickShopItems,
  getMonetateMoreOfWhatYouLoveItems,
  getMonetateCombinedOrderProducts,
  getMonetateCombinedMealDealLineNumbers,
  getMonetateBoughtInStoreItems,
  getMonetateShopByListItems,
} from 'redux/modules/monetate/selectors';
import { getMonetateCategories } from 'redux/modules/monetate/selectors/get-monetate-categories';
import getTrolleyLoaded from 'redux/modules/trolley/selectors/get-loaded';
import locator from 'utils/locator';
import { getUntriggeredPromotionIds } from 'redux/modules/promotions/selectors';

import { monetateCustomVariables } from './monetate-custom-variables';

const plpPages = [
  BOUGHT_IN_STORE,
  BROWSE,
  CUSTOM_AISLE,
  ENTERTAINING,
  FAVOURITES,
  INTERSTITIALS,
  MEAL_DEALS,
  MISSED_OFFERS,
  MORE_OF_WHAT_YOU_LOVE,
  MULTI_SEARCH,
  OFFERS,
  SEARCH,
  SHOP_FROM_ORDER,
  SHOPPING_LISTS,
  VIEW_ORDER,
  QUICK_SHOP,
  SHOP_BY_LIST,
];

const getProductLineNumbers = (pageType, state) => {
  switch (pageType) {
    case MEAL_DEALS:
      return getMonetateCombinedMealDealLineNumbers(state);
    case FAVOURITES:
      return getMonetateCombinedFavourites(state);
    case BOUGHT_IN_STORE:
      return getMonetateBoughtInStoreItems(state);
    case QUICK_SHOP:
      return getMonetateQuickShopItems(state);
    case MORE_OF_WHAT_YOU_LOVE:
      return getMonetateMoreOfWhatYouLoveItems(state);
    case SHOP_FROM_ORDER:
      return getMonetateCombinedOrderProducts(state);
    case MISSED_OFFERS:
      return getUntriggeredPromotionIds(state);
    case SHOP_BY_LIST:
      return getMonetateShopByListItems(state);
    default:
      return getMonetateCombinedProducts(state);
  }
};

export const createPayload = (state = {}, location) => {
  const props = [];
  const isTrolleyLoaded = getTrolleyLoaded(state);
  const pageType = getPageType(location?.pathname);
  const purchaseRows = pageType === ORDER_CONFIRMATION && unstashObject(ADD_PURCHASE_ROWS_KEY);

  // breadcrumbs
  props.push([
    'addBreadcrumbs',
    getMonetateBreadcrumbs(state, {
      location,
    }),
  ]);

  if (purchaseRows) {
    // purchases - incompatible with addCartRows
    props.push(['addPurchaseRows', purchaseRows]);
  } else if (isTrolleyLoaded) {
    // cart items - incompatible with addPurchaseRows
    props.push(['addCartRows', getMonetateCartItems(state)]);
  }

  // categories
  props.push(['addCategories', getMonetateCategories(state, locator?.pathname)]);
  // custom variables
  props.push(['setCustomVariables', monetateCustomVariables(state)]);

  if (plpPages.includes(pageType)) {
    // products
    props.push(['addProducts', getProductLineNumbers(pageType, state)]);
  }

  // type
  props.push(['setPageType', pageType]);
  // retrack
  props.push(['trackData']);

  props.forEach(prop => monetateQ.push(prop));
};
